import { useEffect, useState } from 'react';
import { CommonEquipmentService, Equipment, RootState, ShortUser } from '@umanforge/common';
import { UserService } from 'services/users.service';
import { useDispatch, useSelector } from 'react-redux';
import { ChartFilter } from 'interfaces/chart.interface';
import { TaskActionService } from 'services/taskAction.service';
import { LocationService } from 'services/location.service';
import { Location } from 'interfaces/location.interface';
import { TaskAction } from 'interfaces/taskAction.interface';


const useFilterSelector = (
  sectorId: string,
  onChange: ( filters: ChartFilter ) => void
) => {
  const token = useSelector( ( state: RootState ) => {return state.token.value;} );
  const dispatch = useDispatch();

  const [ isFirstRender, setIsFirstRender ] = useState<boolean>( true );

  const [ taskActions, setTaskActions ] = useState<TaskAction[]>( [] );
  const [ locations, setLocations ] = useState<Location[]>( [] );
  const [ equipments, setEquipments ] = useState<Equipment[]>( [] );
  // const [ timeGrids, setTimeGrids ] = useState<TimeGrid[]>( [] );
  const [ users, setUsers ] = useState<ShortUser[]>( [] );

  const [ selectedTaskActions, setSelectedTaskActions ] = useState<string[]>( [] );
  const [ selectedLocations, setSelectedLocations ] = useState<string[]>( [] );
  const [ selectedEquipments, setSelectedEquipments ] = useState<string[]>( [] );
  // const [ selectedTimeGrids, setSelectedTimeGrids ] = useState<string[]>( [] );
  const [ selectedUsers, setSelectedUsers ] = useState<string[]>( [] );

  const [ filters, setFilters ] = useState<ChartFilter>();

  useEffect( () => {
    if ( isFirstRender ) {
      init();
    }
  }, [] );

  useEffect( () => {
    setSelectedTaskActions( [] );
    setSelectedLocations( [] );
    setSelectedEquipments( [] );
    // setSelectedTimeGrids( [] );
    setSelectedUsers( [] );
    fecthPlanningData();
  }, [ sectorId ] );

  const init = () => {
    fecthPlanningData().then( () => {
      setIsFirstRender( false );
    } );
  };

  const handleChange = () => {
    const filterLocations = [ ...new Set( selectedLocations ) ];
    const filterTypeActions = [ ...new Set( selectedTaskActions ) ];
    const filterEquipments = [ ...new Set( selectedEquipments ) ];
    const filterUsers = [ ...new Set( selectedUsers ) ];
    // const filterTimeGrids = [ ...new Set( selectedTimeGrids ) ];
    const _filters = {
      filterLocations,
      filterTypeActions,
      filterEquipments,
      filterUsers,
      // filterTimeGrids
    };
    setFilters( _filters );
    onChange( _filters );
  };

  useEffect( () => {
    handleChange();
  }, [
    selectedTaskActions,
    selectedLocations,
    selectedEquipments,
    // selectedTimeGrids,
    selectedUsers
  ] );


  const onChangeFilteredLocations = ( locationId: string, value: boolean ) => {
    if ( value ) {
      setSelectedLocations( [ ...selectedLocations, locationId ] );
    }
    else {
      const copyFilterLocations = [ ...selectedLocations ];
      const index = copyFilterLocations.findIndex( location => { return location === locationId; } );
      if ( index != -1 ) {
        copyFilterLocations.splice( index, 1 );
      }
      setSelectedLocations( copyFilterLocations );
    }
  };

  const onChangeFilteredTaskActions = ( taskActionId: string, value: boolean ) => {
    if ( value ) {
      setSelectedTaskActions( [ ...selectedTaskActions, taskActionId ] );
    }
    else {
      const copyFilterTaskActions = [ ...selectedTaskActions ];
      const index = copyFilterTaskActions.findIndex( taskAction => { return taskAction === taskActionId; } );
      if ( index != -1 ) {
        copyFilterTaskActions.splice( index, 1 );
      }
      setSelectedTaskActions( copyFilterTaskActions );
    }
  };

  const onChangeFilteredEquipments = ( equipmentId: string, value: boolean ) => {
    if ( value ) {
      setSelectedEquipments( [ ...selectedEquipments, equipmentId ] );
    }
    else {
      const copyFilterEquipments = [ ...selectedEquipments ];
      const index = copyFilterEquipments.findIndex( equipment => { return equipment === equipmentId; } );
      if ( index != -1 ) {
        copyFilterEquipments.splice( index, 1 );
      }
      setSelectedEquipments( copyFilterEquipments );
    }
  };

  const onChangeFilteredUsers = ( userId: string, value: boolean ) => {
    if ( value ) {
      setSelectedUsers( [ ...selectedUsers, userId ] );
    }
    else {
      const copyFilterUsers = [ ...selectedUsers ];
      const index = copyFilterUsers.findIndex( user => { return user === userId; } );
      if ( index != -1 ) {
        copyFilterUsers.splice( index, 1 );
      }
      setSelectedUsers( copyFilterUsers );
    }
  };

  // const onChangeFilteredTimeGrids = ( timeGridId: string, value: boolean ) => {
  //   if ( value ) {
  //     setSelectedTimeGrids( [ ...selectedTimeGrids, timeGridId ] );
  //   }
  //   else {
  //     const copyFilterTimeGrids = [ ...selectedTimeGrids ];
  //     const index = copyFilterTimeGrids.findIndex( timeGrid => { return timeGrid === timeGridId; } );
  //     if ( index != -1 ) {
  //       copyFilterTimeGrids.splice( index, 1 );
  //     }
  //     setSelectedTimeGrids( copyFilterTimeGrids );
  //   }
  // };


  const fecthPlanningData = async () => {
    const [ _taskActions, _locations, _equipments, _users ] = await Promise.all( [  //, _timeGrids
      TaskActionService.getTaskActionBySector( sectorId, token, dispatch ),
      LocationService.getLocationBySector( sectorId, token, dispatch ),
      CommonEquipmentService.getAllowedEquipmentsBySectorsId( [ sectorId ], token, dispatch ),
      // TimeGridService.getEnableTimeGridsBySectorId( sectorId, token, dispatch ),
      UserService.getUsersOfSector( sectorId, token, dispatch ),

    ] );
    setTaskActions( _taskActions );
    setLocations( _locations );
    setEquipments( _equipments );
    // setTimeGrids( _timeGrids );
    setUsers( _users );
  };

  return {
    filters,

    taskActions,
    locations,
    equipments,
    // timeGrids,
    users,

    onChangeFilteredLocations,
    onChangeFilteredTaskActions,
    onChangeFilteredEquipments,
    onChangeFilteredUsers,
    // onChangeFilteredTimeGrids,
    selectedTaskActions,
    selectedLocations,
    selectedEquipments,
    // selectedTimeGrids,
    selectedUsers,
    setSelectedTaskActions,
    setSelectedLocations,
    setSelectedEquipments,
    setSelectedUsers,
  };
};

export default useFilterSelector;
